import { Directive, inject, OnInit, signal } from '@angular/core';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { UiComponent } from '@df/ui/ui.component';
import { DeliveryEstimationService } from 'projects/app-default/src/app/basket/delivery-estimation.service';
import { DropdownOption } from 'projects/app-default/src/app/ui/common/type-dropdown/type-dropdown.component';
import { NDeliveryConfiguration } from './delivery-info.interfaces';

/**
 * Abstract base component containing shared delivery logic
 * Used by both modal and page delivery components
 */
@Directive()
export abstract class AbstractDeliveryInfoComponent extends UiComponent implements OnInit {
    protected dfApiConfigService = inject(DfApiConfigService);
    protected deliveryEstimationService = inject(DeliveryEstimationService);

    public term: string = '';
    public countryCode: string = this.dfApiConfigService.apiConfig!.defaultCountry;
    protected configuration!: NDeliveryConfiguration.ISampleConfigurationEntry[];
    public matchingConfiguration?: NDeliveryConfiguration.ISampleConfigurationEntry;
    protected matchingConfigurationMethods?: NDeliveryConfiguration.IMethod[];
    public countries = signal<DropdownOption<string>[]>([]);

    override ngOnInit(): void {
        this.init();
        super.ngOnInit();
    }

    public onCountrySelected(countryCode: string): void {
        this.countryCode = countryCode;
        this.applyConfiguration();
    }

    public getEstimatedDate(method: NDeliveryConfiguration.IMethod): string | undefined {
        return this.deliveryEstimationService.getDeliveryEstimationInfo(method);
    }

    private applyConfiguration(): void {
        this.matchingConfiguration = this.configuration.find(i => i.country === this.countryCode);
        this.matchingConfigurationMethods = Object.values(this.matchingConfiguration?.methods || {});
        this.detectChanges();
    }

    private async init() {
        if (!this.dfApiConfigService.countries) {
            await this.dfApiConfigService.loadCountries();
        }
        this.configuration = this.dfApiConfigService.apiConfig!.scurri_sample_configuration || [];
        const countryCodes = this.configuration.map(i => i.country);
        this.countries.set(
            this.dfApiConfigService.countries!.filter(i => countryCodes.includes(i.code)).map(i => ({ label: i.name, value: i.code }))
        );
        this.applyConfiguration();
    }
}
